export const UISETTINGS = {
  UPDATE_USER: 'uisettings/UPDATE_USER',
  UPDATE_ZONE_SCHDULE: 'uisettings/UPDATE_ZONE_SCHDULE',
} as const;
